import type { NodeType } from '@gitbook/slate';

import { BLOCK_PARAGRAPH } from '../types';

/**
 * Returns true if the node only contains just one piece of text with no formatting.
 */
export function isPureText(node: NodeType): boolean {
    switch (node.object) {
        case 'document':
            return node.nodes.size === 1 && isPureText(node.nodes.first()!);
        case 'block':
            return node.type === BLOCK_PARAGRAPH && node.nodes.every(isPureText);
        case 'inline':
            return false;
        case 'text':
            return node.getMarks().isEmpty();
        default:
            return false;
    }
}
